import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { ContainerProps } from './types.js';

/** `<Container>` component. */
export const Container = ({ children, className, ...props }: ContainerProps): ReactElement => (
  <div className={twMerge('rounded border border-base-100 bg-base-300', className)} {...props}>
    {children}
  </div>
);
